import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'index',
      component: Home
    },
    {
      path: '/admin/:id',
      name: 'admin',
      component: () => import(/* webpackChunkName: "admin" */ './views/Admin.vue')
    },
    {
      path: '/payment/add',
      name: 'add',
      component: () => import(/* webpackChunkName: "add" */ './views/payment/Add.vue')
    },
    {
      path: '/payment/success',
      name: 'success',
      component: () => import(/* webpackChunkName: "success" */ './views/payment/Success.vue')
    },
    {
      path: '/payment/cancel',
      name: 'cancel',
      component: () => import(/* webpackChunkName: "cancel" */ './views/payment/Cancel.vue')
    },
    {
      path: '/builder',
      name: 'create',
      component: () => import(/* webpackChunkName: "create" */ './views/Create.vue')
    },
    {
      path: '/builder/:user',
      name: 'view',
      component: () => import(/* webpackChunkName: "view" */ './views/View.vue')
    },
    {
      path: '/signoff/:user',
      name: 'view',
      component: () => import(/* webpackChunkName: "view" */ './views/SignOff.vue')
    },
    {
      path: '/share/:id',
      name: 'share',
      component: () => import(/* webpackChunkName: "share" */ './views/Share.vue')
    },
    {
      path: '/edit/:id',
      name: 'edit',
      component: () => import(/* webpackChunkName: "edit" */ './views/Edit.vue')
    },
    {
      path: '/form/:bslug/:fslug',
      name: 'getForm',
      component: () => import(/* webpackChunkName: "edit" */ './views/Share.vue')
    },
    {
      path: '/password/:key',
      name: 'passwordreset',
      component: () => import(/* webpackChunkName: "edit" */ './views/Password.vue')
    },
    {
      path: '/auth/:id/:token',
      name: 'auth',
      component: () => import(/* webpackChunkName: "edit" */ './views/Auth.vue')
    },
    {
      path: '/:ta',
      name: 'index',
      component: Home
    },
    {
      path: "*",
      name: '404',
      component: () => import(/* webpackChunkName: "edit" */ './views/Error.vue')
    }
  ]
})
